import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { useDispatch, useSelector } from 'react-redux';
import InvoiceForm from './InvoiceForm';
import ProgressBar from '../../common/ProgressBar/ProgressBar';
import { getInvoiceReferenceData } from '../../../redux/invoices/invoiceReferenceSlice';
import { getHeading } from '../../common/commonUtils/commonUtils';

const InvoiceList = () => {
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [formLoading, setFormLoading] = useState(true);

  const getInvoiceReferenceDataSucceeded = useSelector(
    (state) => state.invoiceReferenceData?.succeeded
  );

  useEffect(() => {
    if (getInvoiceReferenceDataSucceeded) {
      setFormLoading(false);
    }
  }, [formLoading, getInvoiceReferenceDataSucceeded]);

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchReferenceData();
    }
    getUser().then((userData) => setUser(userData));
  }, [user?.signInUserSession.accessToken.jwtToken]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const fetchReferenceData = async () => {
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    dispatch(getInvoiceReferenceData(authorization));
  };

  return (
    <>
      {getHeading('Invoices')}
      {formLoading ? (
        <ProgressBar />
      ) : (
        <>
          <InvoiceForm />
        </>
      )}
    </>
  );
};

export default InvoiceList;
